var _rect, _g, _rect2, _rect3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalSubscriptionDiamondIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_324_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-43 -296C-43 -298.761 -40.7614 -301 -38 -301H158.599H168H177.923H374C376.761 -301 379 -298.761 379 -296V230C379 232.761 376.761 235 374 235H-38C-40.7614 235 -43 232.761 -43 230V-296Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -16.5,
    y: -11.5,
    width: 365,
    height: 138,
    rx: 5.5,
    stroke: "#D1D1D1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    rx: 5,
    fill: "#ECF7F0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_324_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7429 7H23.0274C23.1523 6.99998 23.2754 7.02953 23.3867 7.08621C23.4981 7.1429 23.5944 7.22513 23.6678 7.32617L26.6944 11.4872C26.7482 11.5612 26.7747 11.6516 26.7693 11.743C26.764 11.8343 26.7271 11.921 26.6651 11.9883L17.6757 21.7266C17.6386 21.7666 17.5937 21.7986 17.5437 21.8204C17.4937 21.8423 17.4397 21.8536 17.3852 21.8536C17.3306 21.8536 17.2766 21.8423 17.2266 21.8204C17.1766 21.7986 17.1317 21.7666 17.0946 21.7266L8.10524 11.9891C8.04297 11.9218 8.00602 11.8349 8.00067 11.7434C7.99533 11.6518 8.02194 11.5613 8.07595 11.4872L11.1025 7.32617C11.1759 7.22513 11.2723 7.1429 11.3836 7.08621C11.4949 7.02953 11.618 6.99998 11.7429 7Z",
    fill: "#8DD4AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_324_2",
    x: -57,
    y: -311,
    width: 450,
    height: 564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_324_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_324_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_324_2",
    x: 4,
    y: 7,
    width: 26.7695,
    height: 22.8536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905833 0 0 0 0 1 0 0 0 0 0.946948 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_324_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_324_2",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalSubscriptionDiamondIcon);
export default __webpack_public_path__ + "static/media/NormalSubscriptionDiamondIcon.2ea6f81828ced84b2191a10dda32768b.svg";
export { ForwardRef as ReactComponent };